import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8500';
const API_KEY = process.env.REACT_APP_API_KEY || '';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  if (API_KEY) {
    config.headers.Authorization = API_KEY;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.detail || error.message || 'Error de conexion';
    return Promise.reject(new Error(message));
  }
);

export default api;
